import { Pipe, PipeTransform } from '@angular/core';
import { PROFILE_ACCESS } from '@app/config/role-name.enum';

@Pipe({
  name: 'roleName'
})
export class RoleNamePipe implements PipeTransform {

  transform(userRole: string): string {

    const translatedName = PROFILE_ACCESS[userRole]?.translatedName;

    return translatedName ? translatedName : userRole;
  }
}
